import { render, staticRenderFns } from "./DatasetActions.vue?vue&type=template&id=644eae1e"
import script from "./DatasetActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetActions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports